import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as actions from '../actions/departments.actions';
import { MwDepartmentsApiService } from 'app/services/departments-api.service';

@Injectable()
export class DepartmentsEffects {
  loadDepartments$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.loadDepartments),
      switchMap(() =>
        this.departmentsApiService.getDepartments().pipe(
          map((items) => actions.loadDepartmentsSuccess({ items })),
          catchError((error) => of(actions.loadDepartmentsFailed({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private departmentsApiService: MwDepartmentsApiService
  ) {}
}
